var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"container"},[_vm._v(" © Copyright "+_vm._s(new Date().getFullYear())+" The Master Plumbers and Gasfitters Association of Western Australia. ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }